import { callAPI } from '../../../utils/call-api'

export const getAnnouncements = async ({ params, token }) => {
  const response = await callAPI(
    {
      url: `/announcements`,
      method: 'get',
      params: {
        ...params,
      },
    },
    token
  )
  return response.data
}

export const postAnnouncementView = async ({ id, token }) => {
  const response = await callAPI(
    {
      url: `/announcements/${id}/view`,
      method: 'post',
    },
    token
  )
  return response.data
}
